import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { loadRdsPartners } from '../../actions/rdsPartners';

class RdsPartnerSelector extends React.Component {
  constructor(props) {
    super(props)
    this.getDefaultOptions = this.getDefaultOptions.bind(this)
    this.state = {
      partnerSubscriptionId: this.props.SelectedId
    }
  }

  componentDidMount() {
    this.props.loadRdsPartners()
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.tenant !== this.props.tenant) {
      this.props.loadRdsPartners()
    }

    if (prevProps.SelectedId !== this.props.SelectedId) {
      this.setState((state) => {
        return {
          ...state,
          partnerSubscriptionId: this.props.SelectedId || "",
        };
      });
    }
  }

  isValid() {
    return this.state.partnerSubscriptionId !== null && this.state.partnerSubscriptionId !== undefined 
        && this.state.partnerSubscriptionId !== "" && this.state.partnerSubscriptionId !== "0"
        && this.state.partnerSubscriptionId !== "-1"
  }

  getDefaultOptions() {
    let options = null;
    if (this.isValid()) 
    {
      let partner = this.props.rdsPartners.find((partner) => partner.id.toString() === this.state.partnerSubscriptionId)
      if (partner === undefined) {
        options = <option key={this.state.partnerSubscriptionId} value={this.state.partnerSubscriptionId}>Unknown ({this.state.partnerSubscriptionId})</option>
      }
    }
    return options
  }

  render() {
    return (
      <div className="form-group">
        <label htmlFor="name">Partner subscription</label>
        <select
          id="rdsPartner"
          disabled={this.props.disabled}
          className={`custom-select ${this.isValid() ? "" : " is-invalid"}`}
          value={this.state.partnerSubscriptionId}
          onChange={(event) => {
            let val = event.target.value;
            this.setState({partnerSubscriptionId: val});
            this.props.onChange(val);
          }}
          required
        >
          <option key="" value="">None</option>
          {this.getDefaultOptions()}
          {this.props.rdsPartners.map((partner) => <option key={partner.id} value={partner.id}>{partner.name}</option>)}
        </select>
      </div>
    )
  }
}

RdsPartnerSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  rdsPartners: PropTypes.array,
  SelectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loadRdsPartners: PropTypes.func.isRequired,
  tenant: PropTypes.string,
  disabled: PropTypes.bool
}

RdsPartnerSelector.defaultProps = {
  rdsPartners: [],
  SelectedId: '',
  tenant: '',
  disabled: false
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    rdsPartners: state.rdsPartners.rdsPartners,
    tenant: state.system.tenant
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
      loadRdsPartners,
    }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(RdsPartnerSelector)



// WEBPACK FOOTER //
// ./src/components/rdsPartnerSelector/index.js